import styled from "styled-components";

export const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  text-align: center;
  margin-top: 12px;
  margin-bottom: 28px;
`;

export const CarouselSection = styled.div`
  margin-bottom: 32px;
`;

export const PlayerSection = styled.div`
  display: flex;
  justify-content: center;
`; 